
import OjtMinimal from './ojt-minimal';
import './App.css';

function App() {
  return <OjtMinimal />;
}

export default App;
